module.exports = __webpack_public_path__ + "img/bf06fe2.jpg";